<template>
  <div>
    <ValidationObserver ref="addressInfo">
      <b-row class="mt-5">
        <b-col md="6">
          <b-form>
            <b-form-group
              class="d-flex primary-dark mb-5 general-info-form-group"
              label="Address info"
            >
              <b-card class="d-flex flex-column general-info-card pt-3">
                <div class="d-flex flex-wrap">
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-5" md="6">
                      <b-form-group label="Country *">
                        <multiselect
                          :disabled="!isSelf"
                          placeholder="Select country"
                          v-model="selectedCountry"
                          label="text"
                          track-by="id"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          hideSelected
                          class="custom-multiselect mb-3 countries-multiselect"
                          :class="[!isSelf ? 'multiselect-disabled' : null]"
                          :options="countries"
                        > 
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ ellipsify(option.text, 20) }}
                          </template>
                          <template slot="noResult"
                            >No countries found</template
                          ></multiselect
                        >
                      </b-form-group>
                    </b-col>
                    <b-col class="mb-4" md="6">
                      <ValidationProvider
                        name="City field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="City*">
                          <b-form-input
                            v-model="city"
                            placeholder="Enter city name"
                            :disabled="!isSelf"
                            type="text"
                          ></b-form-input>
                          <h6
                            v-if="errors[0]"
                            class="font-sm font-family-regular position-absolute danger"
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-5">
                      <ValidationProvider
                        name="Address line 1"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Address line 1 *">
                          <b-form-input
                            placeholder="Enter address"
                            v-model="address.streetName"
                            :disabled="!isSelf"
                          ></b-form-input>
                        </b-form-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-absolute danger reduce-whitespace-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Address line 2"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Address line 2 *">
                          <b-form-input
                            placeholder="Enter another address"
                            :disabled="!isSelf"
                            v-model="address.streetNumber"
                          ></b-form-input>
                        </b-form-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-absolute danger reduce-whitespace-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-col>
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Postal Code"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Zip code*">
                          <b-form-input
                            placeholder="Enter Zip code"
                            :disabled="!isSelf"
                            v-model="postalCode"
                          ></b-form-input>
                        </b-form-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-absolute danger reduce-whitespace-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="6">
          <div>
            <b-form>
              <b-form-group
                class="d-flex general-info-form-group primary-dark full-width-form"
                label="Communication platforms"
              >
                <b-card
                  v-if="communicationsList.length > 0"
                  no-body
                  class="d-flex flex-column general-info-card mb-5"
                >
                  <b-card-body>
                    <div class="d-flex flex-wrap">
                      <b-row
                        v-for="item in communicationsList"
                        :key="item.id"
                        class="communications-row d-flex align-items-center nowrap w-125"
                      >
                        <b-col
                          style="bottom: 0.5rem;"
                          md="4"
                          class="position-relative"
                        >
                          <div class="communication-type">
                            <img
                              class="position-relative"
                              :src="item.communication.mediumThumbnail"
                              alt
                            />
                            <p
                              :class="[
                                item.communication.medium ===
                                  'Secondary Email' ||
                                item.communication.medium === 'Cell phone'
                                  ? 'reduce-line-height'
                                  : null
                              ]"
                              class="font-weight-normal"
                            >
                              {{ item.communication.medium }}
                            </p>
                          </div>
                        </b-col>

                        <b-col
                          md="8"
                          class="mb-3 communications-textbox position-absolute pr-5"
                        >
                          <b-form-group>
                            <b-form-input
                              autocomplete="off"
                              size="lg"
                              type="text"
                              v-model="item.value"
                              :disabled="!isSelf"
                              placeholder="N/A"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-body>
                </b-card>
                <b-card
                  v-else
                  no-body
                  class="d-flex flex-column general-info-card mb-5"
                >
                  <b-card-body>
                    <div class="d-flex flex-wrap">
                      <b-row
                        v-for="item in communicationIdsList"
                        :key="item.id"
                        class="communications-row d-flex align-items-center nowrap w-125"
                      >
                        <b-col
                          style="bottom: 0.5rem;"
                          md="4"
                          class="position-relative"
                        >
                          <div class="communication-type">
                            <img
                              class="position-relative"
                              :src="item.mediumThumbnail"
                              alt
                            />
                            <p class="font-weight-normal">
                              {{ item.medium }}
                            </p>
                          </div>
                        </b-col>

                        <b-col
                          md="8"
                          class="mb-3 communications-textbox position-absolute pr-5"
                        >
                          <b-form-group>
                            <b-form-input
                              autocomplete="off"
                              size="lg"
                              type="text"
                              v-model="item.value"
                              :disabled="!isSelf"
                              placeholder="N/A"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-body>
                </b-card>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="showValidity">
        <div class="ml-4 mb-3 form-invalid-error-container">
          <p>There are invalid form fields</p>
        </div>
      </b-row>
      <b-row v-else-if="tokenError">
        <div class="ml-4 mb-3 form-invalid-error-container">
          <p>User token expired. Please logout and login again.</p>
        </div>
      </b-row>
      <b-row v-else>
        <div class=" ml-4 mb-3 form-valid-container" v-if="successMessage">
          <p class="font-weight-normal">Profile Updated</p>
        </div>
        <div
          v-if="errorMessage"
          class="ml-4 mb-3 form-invalid-error-container-2"
        >
          <p class="font-weight-normal">Some error occured</p>
        </div>
      </b-row>
      <b-row v-if="isSelf">
        <b-button
          class="btn-pill px-5 py-3 mb-5"
          style="margin-left:2rem"
          @click="saveDetails"
        >
          <b-spinner
            v-if="pageLoading"
            style="width: 14px; height: 14px"
            variant="light"
            label="Spinning"
          ></b-spinner>
          {{ `${!pageLoading ? "Save" : ""}` }}
        </b-button>
      </b-row>
    </ValidationObserver>
  </div>
</template>

<script>
import moment from "moment";
import { email } from "vee-validate/dist/rules";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import Multiselect from "vue-multiselect";
import {
  getCommunicationIDs,
  getCommunications,
  patchAddress,
  patchCommunications,
  postAddress,
  postCommunications
} from "@/apis/auth";
import { getAssistantCustomers } from "@/apis/customers";
import { mapState } from "vuex";
import { countriesListJSON, internalCustomerEmailSet } from "@/utils/constants";
import { getAdminsDetails } from "@/apis/assistants";
import { ellipsify } from '@/utils/utils'
extend("email", {
  ...email,
  message: "Email is not valid"
});
extend("required", {
  message: () => "This is a required field"
});
export default {
  name: "PAContactInfo",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect
  },
  props: ["isSelf", "tab"],
  watch: {
    tab() {
      if (this.tab === 2) {
        this.getPAInfo();
        this.showValidity = false;
        this.successMessage = false;
        this.errorMessage = false;
      }
    }
  },
  data() {
    return {
      tokenError: false,
      city: "N/A",
      selectedMonthFrom: "",
      selectedMonthTo: "",
      countries: [],
      selectedCountry: { text: "N/A", id: null },
      postalCode: "N/A",
      showValidity: false,
      profileID: "",
      workHours: "",
      communications: [],
      slackUsername: "",
      zoomUsername: "",
      phoneNumber: "",
      gmail: "",
      successMessage: false,
      errorMessage: false,
      pageLoading: false,
      addressId: "",
      inactiveDates: [],
      post: true,
      showInactive: false,
      specialities: "N/A",
      monthsList: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
      ],
      communicationIdsList: [],
      momentFrom: "",
      momentTo: "",
      toMonth: "",
      communicationsList: [],
      address: {
        streetName: "N/A",
        streetNumber: "N/A"
      },
      customersList: []
    };
  },
  created() {
    getCommunicationIDs("all")
      .then(res => {
        this.communicationIdsList = [...res.data.results];
        this.getPAInfo();
      })
      .catch(err => console.log(err));
    this.momentFrom = moment();
    this.momentTo = moment();
    this.countries = countriesListJSON.map(item => {
      return {
        text: item.name,
        id: item.id
      };
    });
  },
  computed: {
    ...mapState("authModule", ["profileUserId", "role"])
  },
  methods: {
    fromSelected(date) {
      this.momentTo = date;
      this.selectedMonthTo = "";
    },
    getSelectedCountry(selected) {
      this.selectedCountry = selected.text;
    },
    ellipsify,
    getPAInfo() {
      getAdminsDetails(this.$route.params.uuid)
        .then(res => {
          let { user, communications } = res.data;
          this.paFullname = `${user.firstName} ${user.lastName} `;
          this.userAvatar = user.avatarThumbnail || null;
          this.userInitials = `${user.firstName} ${user.lastName}`
            .match(/\b(\w)/g)
            .join("");
          let address = res.data.defaultAddress
          let { country } = address
          this.selectedCountry = this.countries.filter(
            item => item.text === country
          )[0];
          // let inactiveDate
          if (address) {
            this.post = false;
            this.addressId = address.id;
          }
          if (communications.length > 0) {
            this.communicationsList = communications;
            // console.
          } else {
            const payloadData = [];
            for (let i = 0; i < this.communicationIdsList.length; i++) {
              payloadData.push({
                communication: this.communicationIdsList[i].id,
                value: ""
              });
            }
            postCommunications(
              this.$route.params.uuid,
              payloadData,
              "assistant"
            )
              .then(() => {
                getCommunications(this.$route.params.uuid, "assistant").then(
                  res => {
                    this.communicationsList = [...res.data.results];
                  }
                );
              })
              .catch(err => {
                console.log(err);
              });
          }
          res.data.addresses.forEach(item => {
            this.city = item.city || "N/A";
            this.selectedCountry = this.countries.filter(
              iter => iter.text === item.country
            );
            this.address.streetName = item.address.streetName;
            this.address.streetNumber = item.address.streetNumber;
            this.postalCode = item.postalCode;
          });
          getAssistantCustomers(res.data.id)
            .then(res => {
              this.customersList = [...res.data.results]
                .map(item => {
                  let {
                    firstName,
                    lastName,
                    email
                  } = item.customer.profile.user;
                  item.customerEmail = email;
                  item.customerFullname = `${firstName} ${lastName} `;
                  item.customerInitials = item.customerFullname
                    .match(/\b(\w)/g)
                    .join("");
                  return item;
                })
                .filter(
                  el =>
                    !internalCustomerEmailSet.has(
                      el.customer.profile.user.email
                    )
                );
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err.response);
          this.$emit("showLoader", false);
        })
        .finally(() => {
          this.$emit("showLoader", false);
        });
    },
    async saveDetails() {
      this.showValidity = false;
      this.tokenError = false;
      const valid = await this.$refs.addressInfo.validate();
      if (valid) {
        this.pageLoading = true;
        if (this.post) {
          this.saveAddress();
        } else {
          this.patchAddress();
        }
        this.patchCommunications();
      } else {
        this.showValidity = true;
      }
    },
    patchCommunications() {
      let data = [];
      for (let i = 0; i < this.communicationsList.length; i++) {
        data.push({
          id: this.communicationsList[i].id,
          value: this.communicationsList[i].value
        });
      }
      patchCommunications(this.$route.params.uuid, data, "admin")
        .then(() => {
          this.successMessage = true;
          this.pageLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.showCommunications = true;
        });
    },
    saveAddress() {
      const address = {
        streetNumber: this.address.streetNumber,
        streetName: this.address.streetName
      };
      const data = {
        city: this.city,
        country: this.selectedCountry.text,
        address: address,
        postalCode: this.postalCode
      };
      postAddress(this.profileUserId, data, "admin")
        .then(() => {})
        .catch(err => {
          console.log(err.response);
        });
    },

    patchAddress() {
      const address = {
        streetNumber: this.address.streetNumber,
        streetName: this.address.streetName
      };
      const data = {
        city: this.city,
        country: this.selectedCountry.text,
        address: address,
        postalCode: this.postalCode
      };
      patchAddress(this.profileUserId, data, this.addressId, "admin")
        .then(() => {})
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;

<style scoped lang="scss">
.communications-row:first-child {
  margin-top: 2rem;
}
.communications-row:not(:first-child) {
  margin-top: 1.5rem;
}
.communications-row {
  padding-bottom: 15px;
}
.communications-row:last-child {
  padding-bottom: 6px;
}
.communications-textbox {
  right: 0;
}
.communication-icons {
  width: 40px;
  height: 40px;
}
.communication-icons img {
  object-fit: cover;
  width: inherit;
  position: relative;
  bottom: 0rem;
}
.communication-type {
  padding-left: 15px;
  img {
    display: none;
  }
}
</style>
